<template>
  <div class="about-us">
    <v-container style="padding-top:0px" fluid>
      <v-row align="center" justify="center" class="tier-2 header">
        <v-col cols="12" md="6" lg="6" xl="6" class=" d-flex flex-column">
          <h2 class="tear-2-header">{{ $t("sobreNosotros.title") }}</h2>
        </v-col>
        <v-col cols="12" md="6" lg="6" xl="6" class=" d-flex  flex-column ">
          <p class="body header-description white--text notranslate">
            {{ $t("sobreNosotros.content") }}
          </p>
        </v-col>
        <div class="curve">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              class="shape-fill"
            />
          </svg>
        </div>
      </v-row>

      <v-container style="margin-top:100px">
        <v-row justify="center">
          <v-col data-aos="fade-right" md="6" xl="4" lg="4" cols="12">
            <!-- <v-col data-aos="fade-right" xl="10" lg="10" cols="12"> -->
            <h5 class="notranslate">{{ $t("mensaje_bienvenida.title") }}</h5>
            <p class="body mt-3 mb-8 notranslate" v-html="$t('mensaje_bienvenida.content')" />
          </v-col>

          <v-col
            data-aos="fade-left"
            md="6"
            xl="6"
            lg="6"
            cols="12"
            class="d-flex justify-center pt-8"
          >
            <iframe
              width="560"
              height="315"
              :src="this.$info.about.information.institutionalVideo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-col>

          <v-col data-aos="fade-right" cols="10" class="justify-center d-flex">
            <v-card class="py-5 pr-5" flat hover>
              <h5>{{ $t("mision.title") }}</h5>
              <p class="body">
                Generar, difundir, divulgar, aplicar y transferir el conocimiento de las ciencias
                del mar, del ambiente, de la acuacultura y del desarrollo e innovación tecnológica,
                así como formar recursos humanos de alto nivel, competentes e innovadores con una
                visión de desarrollo sustentable global, para promover la conservación y el
                aprovechamiento racional de los recursos naturales en beneficio de la sociedad y del
                ambiente.
              </p>
            </v-card>
          </v-col>
          <v-col data-aos="fade-left" cols="10" class="justify-center d-flex ">
            <v-card class="py-5 pr-5" flat hover>
              <h5>{{ $t("vision.title") }}</h5>
              <p class=" body">
                En el año 2030, el Instituto de Investigaciones Oceanológicas de la UABC es
                ampliamente reconocido en los ámbitos local, nacional e internacional, por ser un
                Instituto que incide eficazmente en los problemas sociales, ambientales y
                tecnológicos de su competencia, contribuyendo a incrementar el nivel de desarrollo
                humano de la sociedad bajacaliforniana y del país. Es un Instituto con un alto nivel
                de organización en sus Áreas Académicas y cuenta con una eficiente articulación
                entre las mismas. Nuestro personal posee una cultura y actitud humanista, se
                identifica con altos estándares de calidad; es capaz de dar respuesta a las
                exigencias de excelencia en los ámbitos de la investigación científica, el
                desarrollo y aplicación de tecnologías, la formación de recursos humanos, así como
                la identificación y atención a los problemas prioritarios de México.
              </p>
            </v-card>
          </v-col>
        </v-row>

        <v-row style="margin-top:105px" class="notranslate">
          <v-col cols="12" lg="2" xl="2" style="max-width:183px">
            <h3 data-aos="fade-right">{{ $t("personal.title") }}</h3>
          </v-col>
          <v-col xl="9" lg="9" cols="12">
            <v-layout row wrap>
              <v-flex
                class="align-center d-flex xs12 sm6 md6 lg6 xl6"
                v-for="(worker, index) in personal"
                :key="index"
              >
                <WorkerCell data-aos="fade-up" :worker="worker" v-if="validateWorkers(index)" />
              </v-flex>
            </v-layout>
            <div class="personal-bottom" data-aos="fade-up">
              <router-link class="ver-mas" to="/personal">
                {{ $t("personal.subtitle") }}<v-icon v-html="'mdi-chevron-right'" />
              </router-link>
            </div>
          </v-col>
        </v-row>

        <v-row style="margin-top:105px" data-aos="fade-right">
          <v-col cols="12" xl="6" lg="6" class="pa-0">
            <v-img style="align-self:center; " :src="require('../assets/images/IIO_1991.jpg')" />
            <v-img style="align-self:center; " :src="require('../assets/images/IIO1989.jpg')" />
          </v-col>
          <v-col
            cols="12"
            xl="6"
            lg="6"
            :class="show || 'reduced-history '"
            class="book-page pa-10"
          >
            <h5 class="pt-5 notranslate">{{ $t("historia.title") }}</h5>
            <p class="body pt-2 historia-content" v-html="history" />
            <button class=" cta read-more notranslate" @click="show = !show" v-if="showButton">
              {{ $t(!show ? "leerMas" : "leerMenos") }}
            </button>
          </v-col>
        </v-row>

        <v-row v-if="retired.length > 0" class="d-flex flex-column px-3" style="margin-top:105px">
          <!-- <v-col cols="12" lg="2" xl="2" style="max-width:183px"> -->
            <h3 style="max-width:183px" data-aos="fade-right">Nuestros Jubilados</h3>
          <!-- </v-col> -->
            <p class="body mt-3" v-html="retiredChoro"></p>
          <div class="d-flex align-center pt-0 shity-carrousel">
            <v-col v-for="(worker, index) in retired">
              <RetiredCell data-aos="fade-up" :retired="worker" />
            </v-col>
            <div class="arrows">
              <v-icon class="left" v-text="'mdi-chevron-left'" @click.stop="setRetiredIndex(-1)" />
              <v-icon class="right" v-text="'mdi-chevron-right'" @click.stop="setRetiredIndex(1)" />
            </div>
          </div>
        </v-row>

        <v-row class="location notranslate">
          <v-col
            data-aos="fade-right"
            class="pa-7 header col-sm-6 col-md-4 col-lg-4 col-xl-4 col-12 "
          >
            <v-row>
              <v-col class="d-flex flex-column align-start">
                <h6 class="white--text">{{ $t("ubicacion.direccion") }}:</h6>
                <p class="body white--text address">
                  Carretera Ensenada-Tijuana No. 3917, Fracc. Playitas, Ensenada, Baja California,
                  C.P. 22860
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-1 d-flex flex-column align-start">
                <h6 class="white--text">{{ $t("ubicacion.telefono") }}:</h6>
                <p class="body white--text">
                  <a href="tel:6461528222">
                    (646)152-82-22
                  </a>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-1 d-flex flex-column align-start">
                <h6 class="white--text">{{ $t("ubicacion.redesSociales") }}:</h6>
                <div class="d-flex mt-4">
                  <v-btn icon color="white" @click="goToLink(facebook)">
                    <v-icon size="26" v-text="'mdi-facebook'" />
                  </v-btn>
                  <v-btn icon class="ml-3 white--text" @click="goToLink(instagram)">
                    <v-icon size="26" v-text="'mdi-instagram'" />
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="mapa pa-0 col-sm-6 col-md-8 col-lg-8 col-xl-8 col-12" data-aos="fade-left">
            <iframe
              aria-hidden="true"
              style=" width: 100%; height: 100%;  top: 0px; left: 0px; bottom:0px; border: 0;"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3388.6099796486155!2d-116.6684856846281!3d31.86282683733922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d89307e80ce069%3A0xc0c2f086acef21e2!2sInstituto%20de%20Investigaciones%20Oceanol%C3%B3gicas!5e0!3m2!1ses!2smx!4v1632215482998!5m2!1ses!2smx"
              height="500"
              loading="lazy"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <ScrollToTop />
  </div>
</template>
<script>
export default {
  name: "AboutUs",
  data: () => ({
    show: false,
    showButton: window.innerWidth < 893,
    retiredIndex: 0,
    retired: []
  }),
  //{v-container, v-row, v-col, v-img, v-icon, v-btn, v-flex, v-layout, v-card}
  components: {
    ScrollToTop: () => import(/* webpackPrefetch: true */ "../components/Form/scrollToTop.vue"),
    WorkerCell: () => import(/* webpackPrefetch: true */ "../components/Lists/WorkerCell.vue"),
    RetiredCell: () => import(/* webpackPrefetch: true */ "../components/Lists/retiredCell.vue")
  },
  computed: {
    retiredsPerPages() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 3;
      }
    },
    personal: function() {
      return this.$info.about.personal.slice(0, 6);
    },
    history: function() {
      return this.$info.about.information.history;
    },
    facebook: function() {
      return this.$info.about.information.facebook;
    },
    instagram: function() {
      return this.$info.about.information.instagram;
    },
    institutionalVideo: function() {
      return this.$info.about.information.institutionalVideo;
    },
    retiredChoro(){
      return this.$info.about.information.retiredText;
    }
  },
  mounted: function() {
    this.$info.about.retired.sort((a, b) => {
      return new Date(b.fecha) - new Date(a.fecha);
    });
    this.loadRetired();
  },
  created: function() {
    this.loadData;
    window.addEventListener("resize", this.onresize);
  },
  destroyed: function() {
    window.removeEventListener("resize", this.onresize);
  },
  watch: {
    "$vuetify.breakpoint.name": function() {
      this.retiredIndex = 0;
      this.loadRetired();
    }
  },
  methods: {
    goToLink(link) {
      window.open(link);
    },
    setRetiredIndex(val) {
      const { $info, retiredIndex, loadRetired, retiredsPerPages } = this;
      if (
        retiredIndex + val > -1 &&
        retiredIndex + val + retiredsPerPages - 1 < $info.about.retired.length
      ) {
        this.retiredIndex += val;
        loadRetired();
      }
    },
    loadRetired() {
      const { $info, retiredIndex, retiredsPerPages } = this;
      // sort retired by date

      this.retired = $info.about.retired.slice(retiredIndex, retiredIndex + retiredsPerPages);
    },
    onresize: function() {
      this.showButton = window.innerWidth < 893;
    },
    validateWorkers: function(index) {
      if (this.$vuetify.breakpoint["smAndUp"]) {
        return true;
      } else return index < 3;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/global";
.shity-carrousel {
  position: relative;
  transition: all 0.3s;
  width: 100%;
  .arrows {
    position: absolute;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 40px;
    }
    .right {
      width: 40px;
    }
  }
}
.about-us {
  position: relative;

  width: 100%;
  height: 100%;
}
.read-more {
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.tear-2-header {
  text-align: end;
  padding-right: 5vw;
  text-transform: uppercase;
  color: white;
  padding-left: 8px;
}
.header-description {
  max-width: 324px;
  height: 91px;
}
.book-page {
  display: flex;
  flex-direction: column;
  background-color: $yellow;
  transition: height 0.8s;
}

.location {
  margin-top: 87px;
  height: 377px;
}

.reduced-history {
  // overflow-y: scroll;
  height: 813px !important;
  .historia-content {
    overflow-y: scroll;
    max-height: 700px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .historia-content::-webkit-scrollbar {
    display: none;
  }
}

.personal-bottom {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 53px;
  border-top: 1px #bbb solid;
  padding-top: 24px;
  padding-right: 22px;
  .ver-mas {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 28px;
    color: #383838;
    i {
      padding-left: 15px;
    }
  }
}
.address {
  width: 260px;
  height: 88px;
}
@media (max-width: 960px) {
  .tear-2-header {
    padding: 0;
    margin-top: 25px;
    text-align: center;
  }
  .header-description {
    margin: 0 auto;
    margin-top: -125px;
    text-align: center;
  }
}
@media (max-width: 892px) {
  .reduced-history {
    // overflow: hidden;
    height: 630px !important;
    .historia-content {
      overflow: hidden;
      max-height: 590px;
    }
  }
}

@media (max-width: 600px) {
  .mapa {
    width: 100%;
    height: 360px;
  }
  .location {
    height: auto !important;
  }
}
</style>
